import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  agentAvatarLabel: {
    id: 'ai-mate.agent-avatar-label',
    defaultMessage: 'Agent avatar',
    description: 'Accessible label for agent avatar img'
  }
});